import { useProperties } from '../../api/properties';
import {
    Grid, IconButton, Tooltip, Typography, InputLabel
} from '@material-ui/core';
import { PlayCircleOutline } from '@material-ui/icons';
import { DataGrid } from '@mui/x-data-grid';
import { makeStyles } from '@material-ui/core/styles';
import Dimmer from '+/Dimmer';
import Swal from '#/swal';
import { api } from '#/apis';
import { Button } from 'semantic-ui-react';

const useStyles = makeStyles({
    dataGrid: {
        '&.MuiDataGrid-root .MuiDataGrid-columnHeader:focus, &.MuiDataGrid-root .MuiDataGrid-cell:focus': {
            outline: 'none'
        }
    },
    redButton: {
        color: '#fff',
        backgroundColor: '#DB2828'
    }
});

const ListProperties = props => {
    const classes = useStyles();
    const {
        isLoading, isError, data, isFetching
    } = useProperties();


    if (isLoading || isFetching) {
        return <Dimmer />;
    }

    if (isError) {
        return 'Internal Error - Contact Technical Support';
    }

    const run = async (tab, property_id = null) => {

        let endpoint = `/scripts/${tab}`;

        if (property_id) {

            endpoint += `/${property_id}`;
        }

        await api.post(endpoint);
    };

    const handleRunScript = async property => {
        if (property){
            const result = await Swal.fire.warning({
                text: `This will run the Script ${props.tab} for the property ${property.name}`
            });

            if (result.value) run(props.tab, property.id);
        }
        else {
            const result = await Swal.fire.warning({
                text: `This will run the Script ${props.tab} for ALL properties`
            });

            if (result.value) run(props.tab, null);
        }
    };

    const columns = [
        {
            renderHeader: () => <strong> Name </strong>,
            field: 'name',
            flex: 3
        },
        {
            field: 'actions',
            renderHeader: () => <strong>Actions</strong>,
            renderCell: ({ row }) => (

                <div>
                    <Tooltip title='Run' onClick={() => handleRunScript(row)}>
                        <IconButton>
                            <PlayCircleOutline />
                        </IconButton>
                    </Tooltip>

                </div>
            ),
            flex: 1,
            align: 'right',
            headerAlign: 'right'

        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    ];

    let runOnce = props.tab;

    if (runOnce === 'amenity-validator'){
        runOnce = true;
    }
    else {
        runOnce = false;
    }

    return (
        <div>
            { runOnce
                ? (
                    <Button style={{
                        backgroundColor: '#002144',
                        color: 'white',
                        borderRadius: 10,
                        marginLeft: '200px',
                        marginTop: '40px'
                    }} size='massive' onClick={() => handleRunScript(false)}
                    >Run</Button>
                )
                : <div>
                    <Grid container justifyContent='space-between' style={{ marginBottom: '10px' }}>
                        <Grid item>
                            <Typography variant='h4'>

                            </Typography>
                        </Grid>
                        <Grid item>

                            <Tooltip title='Run' onClick={() => handleRunScript(false)}>
                                <IconButton>
                                    <InputLabel fullWidth>Run for All Properties </InputLabel><PlayCircleOutline />
                                </IconButton>
                            </Tooltip>

                        </Grid>
                    </Grid>

                    <DataGrid
                        className={classes.dataGrid}
                        loading={isLoading}
                        columns={columns}
                        rows={data || []}
                        autoHeight
                        disableSelectionOnClick
                        hideFooterSelectedRowCount
                        hideFooterPagination
                    />
                </div>}
        </div>
    );
};

export default ListProperties;
